import usePreviews from "@lib/hooks/use-previews"
import getNumberOfSkeletons from "@lib/util/get-number-of-skeletons"
import repeat from "@lib/util/repeat"
import ProductPreview from "@modules/products/components/product-preview"
import SkeletonProductPreview from "@modules/skeletons/components/skeleton-product-preview"
import { fetchCollectionProducts } from "@pages/akoestische-panelen/[id]"
import { useCart } from "medusa-react"
import React, { FC, useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"
import { useInfiniteQuery, useQuery } from "react-query"
import { FilterStoreGetProductsParams } from "@lib/util/filter-types"
import clsx from "clsx"
import { collectionType } from "@lib/data/collections"
import RenderItem from "@modules/common/render-item"
import fetchReviews from "@lib/util/fetchReviews"
import { ProductPreviewType } from "../../../types/global"
import sortProductsByColor from "@lib/util/product-sort-color"
import sortProductsAdvanced from "@lib/util/product-advanced-sort";

type CollectionTemplateProps = {
    collection: {
        id: string
        title: string
    }
    content?: null | collectionType
}

const CollectionTemplate: React.FC<CollectionTemplateProps> = ({
    collection,
    content
}) => {
    const [params, setParams] = useState<FilterStoreGetProductsParams>({})
    const { cart } = useCart()
    const items = content?.content
    const { ref, inView } = useInView()

    const {
        data: infiniteData,
        hasNextPage,
        fetchNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteQuery(
        [`get_collection_products`, collection.id, cart?.id, params.filters],
        ({ pageParam }) =>
            fetchCollectionProducts({
                pageParam,
                id: collection.id,
                cartId: cart?.id,
                filters: params?.filters ?? {}
            }),
        {
            getNextPageParam: (lastPage) => lastPage.nextPage
        }
    )

    const previews = usePreviews({
        pages: infiniteData?.pages,
        region: cart?.region
    }) /*.map((p) => {
        const reviewData = useQuery(
            [`get_review`, p?.handle, `reviews`],
            () => fetchReviews(p.id),
            {
                enabled: (p?.handle ?? "").length > 0,
                keepPreviousData: true
            }
        )
        const reviews = reviewData.data?.product_reviews ?? []
        if (!reviewData.isSuccess || !reviews.length) return p
        return {
            ...p,
            reviews: {
                average_rating: reviews.reduce(
                    (acc, curr) => acc + curr.rating,
                    0
                ),
                count: reviews.length,
                reviews: reviews
            }
        } as ProductPreviewType
    })*/

    useEffect(() => {
        if (inView && hasNextPage) {
            fetchNextPage()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView, hasNextPage])

    /*useEffect(() => {
        const items = content?.content
        setFirstItem(items?.shift())
        setItems(items)
    }, [content])*/

    const hit = [2, 4, 8]
    return (
        <div className={"grain-background"}>
            <div
                className={
                    "relative z-10 grid grid-cols-1 small:grid-cols-6  px-4 py-7 lg:px-12 lg:py-20"
                }
            >
                <div
                    className={
                        "relative small:absolute z-20 bg-red-600 text-white p-3 small:rounded-full text-[0.8rem] small:text-[19px] small:right-10 small:top-10 text-center w-full md:w-[200px] small:aspect-square flex items-center justify-center"
                    }
                >
                    GRATIS VERZENDING <br />
                    {collection.id === "pcol_01GQDXMFP78WHSFFAHB6K4EV79"
                        ? "SAMPLES"
                        : "AKUPANELEN"}
                    <br />
                    NL &amp; BE
                </div>
                {items && <RenderItem item={items[0]} />}
                {/*<div className="relative block col-span-4 small:col-span-1">
                    <RefinementList
                        refinementList={params}
                        setRefinementList={setParams}
                        showCollection={false}
                        collectionId={collection.id}
                    />
                </div>*/}
                <div className="col-span-6 small:px-8 transition flex flex-col small:items-start py-6">
                    <div className={"small:content-container "}>
                        <ul className="grid grid-cols-2 small:grid-cols-3 medium:grid-cols-4 gap-x-4 gap-y-8">
                            {sortProductsAdvanced(previews).map((p, i) => (
                                <li
                                    key={p.id}
                                    /*className={clsx({
                                        "px-2 col-span-1 md:col-span-2":
                                            hit.includes(i),
                                    })}*/
                                >
                                    <ProductPreview {...p} doubleColl={false} />
                                </li>
                            ))}
                            {isLoading &&
                                !previews.length &&
                                repeat(8).map((index) => (
                                    <li key={index}>
                                        <SkeletonProductPreview />
                                    </li>
                                ))}
                            {isFetchingNextPage &&
                                repeat(
                                    getNumberOfSkeletons(infiniteData?.pages)
                                ).map((index) => (
                                    <li key={index}>
                                        <SkeletonProductPreview />
                                    </li>
                                ))}
                        </ul>
                        <div
                            className="py-4 small:py-16 flex justify-center items-center text-small-regular text-gray-700"
                            ref={ref}
                        >
                            <span ref={ref}></span>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={
                    "relative z-10 grid grid-cols-1 small:grid-cols-6 px-4 small:px-0 py-7"
                }
            >
                {items &&
                    items.map((item, index) =>
                        index === 0 ? <></> : <RenderItem item={item} />
                    )}
            </div>
            <div
                className={"absolute inset-0 z-0 pointer-events-none"}
                style={{
                    background:
                        "linear-gradient(\n" +
                        "    to right,\n" +
                        "    transparent 0%,\n" +
                        "    transparent 33.33%,\n" +
                        "    #f6f6f6 33.33%,\n" +
                        "    #f6f6f6 100%\n" +
                        "  )"
                }}
            >
                &nbsp;
            </div>
        </div>
    )
}

export default CollectionTemplate
